import headerComponent from '@/components/cust_components/cust_header_component.vue';
import CustPopover from '@/components/cust_components/cust_popover_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import cartSlots from './cart_slots.js';

export default {
    name: 'termsComp',
    components: {
        headerComponent,
        CustPopover,
        FooterComponent,
        LoaderPopover
    },
    data() {
        return {
            store_data: [], //////////////////
            terms_scrolled: false,
            slots_not_available: false,
            bookings_data: {},
            unpaid_booking_details: [],
            terms_btn_content: 'Read More',
            footer_color: 'ash_bg',
            block_customer_popup: false,
            popup_mobile: JSON.parse(this.$session.get('store_details')).store_mobile,
            deposit: 0
        }
    },
    mounted() {
        if (this.$session.get('cust_details') && !this.$session.get('service_obj')) {
            this.$router.push('/mybookings');
        }
        this.$session.remove('preview_booking_flag');
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
        this.get_Customer_Store_Details();
    },
    methods: {
        async responsive_view() {
            await this.$store.commit('responsive_view', window.innerWidth)
        },

        async get_Customer_Store_Details() {

            await this.$store.dispatch('getStoreDetails', [this.$store.state.api, this.$store.state.store_url_name])
            this.$ga.page(this.$router);
            if (Object.keys(this.$store.state.cust_store_data).length > 0) {
                this.store_data = this.$store.state.cust_store_data;

            } else {
                this.store_data = [];
            }

            if (this.$refs.terms_content.clientHeight < this.$refs.terms_div.clientHeight) {
                this.terms_scrolled = true;
            }
        },
        close_block_customer_popup() {

            this.block_customer_popup = false;
            this.$session.remove('service_obj');
            this.$session.remove('product_obj');
            this.$session.remove('store_details');
            this.$router.push('/mybookings');
        },
        terms_btn_display() {
            let scroll_top = this.$refs.terms_div.scrollTop;

            if (scroll_top >= (this.$refs.terms_content.scrollHeight - this.$refs.terms_div.offsetHeight) + 2 * this.$refs.terms_content.offsetTop - 5) {
                this.terms_scrolled = true;
                this.footer_color = "green_bg";
                this.terms_btn_content = "I agree with the above T&C";
            } else {
                this.terms_scrolled = false;
                this.footer_color = "ash_bg",
                    this.terms_btn_content = "Read More";
            }
        },
        read_more() {
            this.$refs.terms_div.scrollTop = (this.$refs.terms_content.scrollHeight - this.$refs.terms_div.offsetHeight) + 2 * this.$refs.terms_content.offsetTop;
            this.terms_scrolled = true;
            this.footer_color = "green_bg";
            this.terms_btn_content = "I agree with the above T&C";
        },

        back_to_cart_with_expired_slots(server_past_slots) {
            cartSlots.clear_expired_slots(this.$session, server_past_slots);
            this.$session.set(cartSlots.EXPIRED_NOTICE_KEY, 1);
            this.$store.state.loader_popup = false;
            this.$router.push('/cart');
        },

        async slot_availability() {
            // JOYWEB-3135: a persisted cart can hold a slot that has since passed.
            if (cartSlots.clear_expired_slots(this.$session)) {
                this.back_to_cart_with_expired_slots();
                return;
            }
            this.$store.state.loader_popup = true;
            let session_services = JSON.parse(this.$session.get('service_obj'));
            let slots = [];
            let products = [];
            session_services.forEach(function(serv, cart_index) {
                slots.push(cartSlots.with_cart_index(serv, cart_index));
            })

            if (this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0) {
                let session_products = JSON.parse(this.$session.get('product_obj'));
                session_products.forEach(function(product) {
                    let product_obj = {
                        "product_id": product.product_id,
                        "selected_quantity": product.quantity_selected
                    }
                    products.push(product_obj);
                });
            }

            await this.$store.dispatch('slotsAvailabilityCheck', [this.$store.state.api, slots, products]);

            this.$store.state.slots_available_details.slots.forEach(cart_serv => {
                if (cart_serv.is_available == 0) {
                    this.$store.state.loader_popup = false;
                    this.slots_not_available = true;
                }
            });

            if (this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0) {
                this.$store.state.slots_available_details.products.forEach(cart_product => {
                    if (cart_product.is_available == 0) {
                        this.$store.state.loader_popup = false;
                        this.slots_not_available = true;
                    }
                });
            }


            if (!this.slots_not_available) {
                await this.save_customer();
            }
        },

        async save_customer() {

            var cust_details = JSON.parse(this.$session.get('cust_details'));

            this.bookings_data.store_id = JSON.parse(this.$session.get('store_details')).store_id;
            this.bookings_data.book_email = cust_details.cust_email;
            this.bookings_data.booked_through = 2;
            this.bookings_data.booking_type = 2;

            this.bookings_data.bookings = [];
            var service_details_obj = {};
            this.bookings_data.products = [];

            if (this.$session.get('service_obj') && JSON.parse(this.$session.get('service_obj')).length > 0) {
                var service_details = JSON.parse(this.$session.get('service_obj'));
                for (let i = 0; i < service_details.length; i++) {
                    service_details_obj = {
                        type: "service",
                        service_code: service_details[i].serv_id,
                        service_category: service_details[i].serv_cat_id,
                        user_id: service_details[i].staff_id,
                        user_staff_type_id: service_details[i].user_perm_staff_type,
                        start_date: service_details[i].slot_date,
                        end_date: service_details[i].slot_date,
                        start_time: service_details[i].slot_start_time,
                        end_time: service_details[i].slot_end_time,
                        duration: service_details[i].serv_defdur,
                        service_price: service_details[i].serv_saleprice,
                        deposit: service_details[i].serv_deposit,
                        staff_note: "",
                        quantity: 1

                    }

                    this.bookings_data.bookings.push(service_details_obj);

                }

                if (this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0) {
                    let session_products = JSON.parse(this.$session.get('product_obj'));
                    for (let j = 0; j < session_products.length; j++) {

                        let product_obj = {
                            "product_id": session_products[j].product_id,
                            "product_name": session_products[j].product_name,
                            "product_sku": session_products[j].product_sku,
                            "product_barcode": session_products[j].product_barcode,
                            "product_image_url": session_products[j].product_default_image.product_image_url,
                            "product_thumbnail_url": session_products[j].product_default_image.product_thumbnail_url,
                            "product_date": service_details[0].slot_date,
                            "product_quantity": session_products[j].quantity_selected,
                            "total_product_quantity": session_products[j].product_quantity,
                            "product_full_amount": session_products[j].product_sale_price,
                            "product_book_notes": ""
                        }
                        this.bookings_data.products.push(product_obj);
                    }
                }


                // JOYWEB-2549: ensure the store gateway config is actually loaded before
                // deciding the payment path. get_Customer_Store_Details() runs async in
                // mounted(); if the customer submits before it resolves, store_data is []
                // and store_api_publish_key reads undefined, wrongly forcing is_unpaid=1
                // (booking created without collecting the deposit). Await it here so the
                // decision below is based on real gateway data. (The server also re-enforces
                // this and no longer trusts is_unpaid.)
                if (!this.store_data || !this.store_data.store_id) {
                    await this.get_Customer_Store_Details();
                }

                if (this.bookings_data.bookings.every(key => key.deposit == 0) && this.bookings_data.products.every(key => key.product_full_amount == 0)) {

                    this.bookings_data.is_unpaid = 1

                } else if (this.store_data.store_api_publish_key || (this.store_data.store_api_square_app_id && this.store_data.store_api_square_location_id)) {

                    this.bookings_data.is_unpaid = 0

                } else {
                    this.bookings_data.is_unpaid = 1
                }

            }

            try {
                await this.$store.dispatch('saveBooking', [this.$store.state.api, this.bookings_data]);
            } catch (error) {
                // Server-side guard (device clock may differ from store time).
                if (cartSlots.is_slot_in_past_error(error)) {
                    this.back_to_cart_with_expired_slots(error.response.data.past_slots);
                    return;
                }
                this.$store.state.loader_popup = false;
                throw error;
            }

            if (this.$store.state.save_service_Bookings_details.bookings.length > 0) {
                for (let j = 0; j < this.$store.state.save_service_Bookings_details.bookings.length; j++) {
                    var jsonObj = this.$store.state.save_service_Bookings_details.bookings[j];
                    this.unpaid_booking_details.push(jsonObj)

                }
                this.$session.set('unpaid_booking_details', JSON.stringify(this.unpaid_booking_details));
                await this.$store.dispatch('checkBlockCustomer', [this.$store.state.api, cust_details.cust_email, JSON.parse(this.$session.get('store_details')).store_id])
                if (Object.keys(this.$store.state.block_customer_data).length > 0) {
                    this.$store.state.loader_popup = false;
                    let store_details = JSON.parse(this.$session.get('store_details'));
                    await this.$store.dispatch('checkBlockCustomer', [this.$store.state.api, cust_details.cust_email, store_details.store_id])
                    let banned_data = {

                        "owner_cust_id": this.$store.state.block_customer_data[0].cust_id,
                        "pay_fullpayment": this.$store.state.block_customer_data[0].pay_fullpayment,
                        "cust_banned": this.$store.state.block_customer_data[0].is_banned

                    }
                    this.$session.set('cust_banned_data', JSON.stringify(banned_data));

                    if (this.$store.state.block_customer_data[0].is_banned == 1) {
                        this.block_customer_popup = true;
                    } else {
                        if (this.bookings_data.bookings.every(key => key.deposit == 0) && this.bookings_data.products.every(key => key.product_full_amount == 0)) {
                            this.$router.push('/bookingsuccess')
                        } else if (this.store_data.store_api_publish_key || (this.store_data.store_api_square_app_id && this.store_data.store_api_square_location_id)) {

                            this.$router.push('/custpayment')
                        } else {
                            this.$router.push('/bookingsuccess')
                        }
                    }
                }

            }
        },

        edit_cart() {
            let session_services = JSON.parse(this.$session.get('service_obj'));
            let session_products = [];

            cartSlots.unavailable_cart_indexes(this.$store.state.slots_available_details.slots).forEach(index => {
                delete session_services[index].slot_start_time;
                delete session_services[index].slot_end_time;
                delete session_services[index].slot_date;
            })

            if (this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0) {
                session_products = JSON.parse(this.$session.get('product_obj'));
                this.$store.state.slots_available_details.products.forEach((product_available) => {
                    if (product_available.is_available == 0) {
                        let session_prod_index = session_products.findIndex(session_prod => session_prod.product_id == product_available.product_id);
                        if (product_available.available_quantity == 0) {
                            session_products.splice(session_prod_index, 1);
                        } else {
                            session_products[session_prod_index].quantity_selected = product_available.available_quantity;
                        }
                    }
                })
            }

            if (this.$session.get('service_obj') != JSON.stringify(session_services)) {
                this.$session.set('service_obj', JSON.stringify(session_services));
                this.$session.set('product_obj', JSON.stringify(session_products));
                this.$router.push('/cart')
            } else if (this.$session.get('product_obj') != JSON.stringify(session_products)) {
                this.$session.set('service_obj', JSON.stringify(session_services));
                this.$session.set('product_obj', JSON.stringify(session_products));
                this.$store.state.products_not_available = true;
                this.$router.push('/addproducts')
            }
        },

        remove_slots_available_popup() {
            this.slots_not_available = false;
        }
    }
}